import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation, Trans } from 'react-i18next'
import TwoCol from '../../partials/TwoCol'
import '../../sass/innerPages.sass'
import MainTitle from '../../partials/MainTitle'
import villa from '../../img/villa_mala.jpg'
import villascr from '../../img/villascr.jpg'
import villaFont from '../../img/villaFont.jpg'
import villaTypescaleDesktop from '../../img/villaTypescaleDesktop.jpg'

function Villa() {
  const { t } = useTranslation();
  
  useEffect(()=>{
    window.scrollTo(0, 0);
  },[]);

  return (
    <div className='container'>
      <MainTitle title={t('villaTitle')} />
      <TwoCol contentOne={<ContentOne />} contentTwo={<ContentTwo />} />
      <div className='txtContainer mt-50 px-20'>
        <h2>{t('designDecisions')}</h2>
        <p><Trans i18nKey="villaDDTxt"></Trans></p>
        <figure>
          <img className='image-fluid' src={villaFont} alt="Font" />
          <figcaption>{t('villaFontCaption')}</figcaption>
        </figure>
        <p><Trans i18nKey="villaDDTxt2"></Trans></p>
        <figure>
          <img className='image-fluid' src={villaTypescaleDesktop} alt="Typescale" />
          <figcaption>{t('villaTypeCaption')}</figcaption>
        </figure>
        <p><Trans i18nKey="villaDDTxt3"></Trans></p>
        <ul className='colors'>
          <li><span className='color' style={{background: "#272222"}}></span> #272222</li>
          <li><span className='color' style={{background: "#5b5353"}}></span> #5b5353</li>
          <li><span className='color' style={{background: "#7b6036"}}></span> #7b6036</li>
          <li><span className='color' style={{background: "#b69052"}}></span> #b69052</li>
          <li><span className='color' style={{background: "#D5C6AF"}}></span> #D5C6AF</li>
          <li><span className='color' style={{background: "#FCF9F3"}}></span> #FCF9F3</li>
          <li><span className='color' style={{background: "#F5F5F5"}}></span> #F5F5F5</li>
        </ul>

        <h2>{t('designSystem')}</h2>
        <p><Trans i18nKey="villaDSTxt"></Trans></p>

        <h2>{t('uxApproach')}</h2>
        <p><Trans i18nKey="villaUXTxt" components={{ul: <ul />, li: <li />}}>
        The primary UX goal was to simplify the booking journey and make accommodation browsing feel intuitive and effortless. The interface was structured to guide users naturally through apartment exploration, amenities, and contact information while maintaining a clear visual hierarchy.
        <br /><br />Special attention was given to:
        <ul>
          <li>easy accommodation browsing</li>
          <li>clean information hierarchy</li>
          <li>intuitive navigation</li>
          <li>visually engaging layouts</li>
          <li>accessible booking flow</li>
        </ul>
        The experience was designed to feel calm, elegant, and user-friendly while reflecting the premium character of the villa itself.
        </Trans></p>

        <h2>{t('visualDirection')}</h2>
        <p><Trans i18nKey="villaVDTxt"></Trans></p>

        <h2>{t('figmaScr')}</h2>
        <figure>
          <img className='image-fluid' src={villascr} alt={t('figmaScr')} />
          <figcaption>{t('villaScrCaption')}</figcaption>
        </figure>

        <h2>{t('finalOutcome')}</h2>
        <p><Trans i18nKey="villaFOTxt"></Trans></p>

        <Link className="btn btn-link btn-inner mt-20" to={"https://villamala-split.com/hr/"} target="_blank">{t('seeWebpage')}</Link>
      </div>
    </div>
  )
}

export default Villa

function ContentOne() {
  return(
    <img className="image-fluid" src={villa} alt="Little Villa" />
  );
}

function ContentTwo() {
  const { t } = useTranslation();

  return(
    <div className='innerMain mx-50'>
      <p className='mt-0'>{t('villaMainTxt')}</p>
      <Link className="btn btn-link mt-20" to={"https://villamala-split.com/hr/"} target="_blank">{t('seeWebpage')}</Link>
      <h2 className='mt-50 mb-0'>{t('mainProblem')}</h2>
       <p className='problem'><Trans i18nKey="villaMainText2">
        The main problem to solve was: <br/><i>How to emphasize the luxury of the Villa and present it in the best light, and highlight the apartments themselves.</i>
      </Trans></p>
    </div>
  );
}